var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-details"},[_vm._v(" "+_vm._s(_vm.content)+" "+_vm._s(this.$router.history.current.params.id)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }